export default __webpack_public_path__ + "static/media/brand-placeholder.78831623.jpg";